<template>
	<v-form
		class="reset-password-form"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<v-alert v-model="showSuccess" type="success" dismissible>
			Your password has been changed.
		</v-alert>
		<v-alert v-model="showError" type="error" dismissible> An error occurred. </v-alert>
		<v-row>
			<v-col cols="12" class="mb-0 pb-0">
				<p class="password-recovery-form__description mb-0">Email</p>
				<v-text-field
					disabled
					filled
					readonly
					class="pt-0"
					color="red"
					v-model="fields.email"
					:error-messages="field_errors.email"
					:rules="rules.email"
					required
					placeholder="Enter your email"
				>
				</v-text-field>
			</v-col>
			<v-col cols="12" class="pb-0">
				<p class="password-reset__description mb-0">Password</p>
				<v-text-field
					class="pt-0 password-field"
					:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
					:type="showPassword ? 'text' : 'password'"
					v-model="fields.password"
					required
					:rules="rules.password"
					:error-messages="field_errors.password"
					placeholder="Enter your password"
					@click:append="showPassword = !showPassword"
				>
				</v-text-field>
			</v-col>
			<v-col cols="12" class="pb-0">
				<p class="password-reset__description mb-0">Password Confirmation</p>
				<v-text-field
					class="pt-0 password-field"
					:append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
					:type="showRePassword ? 'text' : 'password'"
					v-model="fields.rePassword"
					required
					:rules="rules.password.concat(passwordConfirmationRule)"
					:error-messages="field_errors.rePassword"
					placeholder="Enter your password"
					@click:append="showRePassword = !showRePassword"
				>
				</v-text-field>
			</v-col>
			<p v-for="error in errors" :key="error" class="text-danger">
				{{ error }}
			</p>
			<v-col cols="12" class="text-center mb-4">
				<v-btn
					class="align-center px-11 py-6 password-reset__submit"
					type="submit"
					:loading="loading"
				>
					Reset Password
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import Form from '../../mixins/Form'
import { mapActions, mapGetters } from 'vuex'
import { rulePassword, ruleRequired } from '@/utils/rules'

export default {
	name: 'PasswordResetForm',
	mixins: [Form],
	data: () => ({
		fields: {
			email: '',
			password: '',
			rePassword: '',
		},
		showPassword: false,
		showRePassword: false,
	}),
	computed: {
		...mapGetters('user', ['showSuccess', 'showError']),
		rules() {
			return {
				password: [
					(v) => ruleRequired(v) || 'Field is required.',
					(v) => rulePassword(v) || 'Password must contain a minimum of 8 characters.',
				],
				rePassword: [
					(v) => ruleRequired(v) || 'Field is required.',
					(v) => rulePassword(v) || 'Password must contain a minimum of 8 characters.',
				],
			}
		},
		passwordConfirmationRule() {
			return () => this.fields.password === this.fields.rePassword || 'Password must match'
		},
		verificationToken() {
			return this.$route.query.token
		},
		userEmail() {
			return this.$route.query.email
		},
	},
	methods: {
		...mapActions('auth', ['passwordReset']),
		submitForm() {
			if (this.verificationToken === undefined || this.userEmail === undefined) {
				throw 'Error'
			}

			const { password, rePassword } = this.fields
			return this.passwordReset({
				email: this.userEmail,
				password,
				password_confirmation: rePassword,
				token: this.verificationToken,
			})
		},
	},
	created() {
		this.fields.email = this.userEmail
	},
}
</script>

<style lang="scss">
.reset-password-form {
	font-family: Montserrat, system-ui;

	.theme--light.v-input input {
		color: #000;
	}

	.v-text-field {
		input {
			padding: 10px 0 20px;
			font-size: 20px;
			font-weight: 500;
			max-height: 50px;
		}
	}

	.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
		color: #e5e5e5;
		border-color: #e5e5e5;
	}

	.password-field {
		.v-input__append-inner {
			margin-top: 0;
			.v-input__icon--append {
				.v-icon {
					color: #e5e5e5;
					padding: 30px 0 20px;
				}
			}
		}
	}

	input::placeholder {
		color: #e5e5e5 !important;
		opacity: 1;
	}

	&__description {
		font-weight: bold;
		font-size: 18px;
	}

	button[type='submit'] {
		border-radius: 54.5px;
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		text-transform: none;
		background-color: #db7842 !important;
		color: #fff;
	}
}
</style>
